import AddEditSection from "../../components/AddEditSection";
import Breadcrumb from "../../parts/Breadcrumb";
import React, { useState, useEffect } from "react";
import configuration from "../../config";
import { toast } from "react-toastify";
import labels from "../../constants/Language";
import _ from "underscore";
import { getAccessRights } from "../../utils/common";
import Loader from "../../components/Loader/Loader";

// For Add Language
function Add({ history }) {
  const [countryOpt, setCountryOpt] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  const statusOpt = [
    //
    { id: 1, title: "Active", value: "active" },
    { id: 2, title: "Inactive", value: "inactive" },
    // { id: 3, title: "Archive", value: "archive" },
  ];
  const [fieldArr, setFieldArr] = useState([
    { id: 0, title: "Title", name: "title", type: "TextInput" },
    { id: 1, title: "Code", name: "code", type: "TextInput" },
    {
      id: 0,
      title: "Country",
      name: "country_id",
      type: "Dropdown",
      options: countryOpt,
    },
    {
      id: 3,
      title: "Status",
      name: "status",
      type: "Dropdown",
      options: statusOpt,
    },
    { id: 0, title: "Flag ", name: "icon", type: "FileInput" },
  ]);

  const [fields, setFields] = useState({});
  const [errors, setErrors] = useState({
    title: "",
    code: "",
  });
  const [icon, setIcon] = useState(null);

  function handleValidation() {
    let flag = true;
    let error = {};
    if (!fields.title) {
      error["title"] = "Please enter language title";
      flag = false;
    }
    if (!fields.code) {
      error["code"] = "Please enter language code";
      flag = false;
    }
    if (!fields.country_id) {
      error["country_id"] = "Please select country";
      flag = false;
    }
    if (!fields.icon) {
      error["icon"] = "Please select flag";
      flag = false;
    }
    if (!fields.status) {
      error["status"] = "Please select status";
      flag = false;
    }
    // console.log(error)
    setErrors({ ...error });
    return flag;
  }
  useEffect(() => {
    getAccessRights().then((rights) => {
      const rightsData = rights?.find((ac) => ac.code === "LANGUAGE");
      if (rightsData?.add === false) {
        history.push("/dashboard");
      }
    });
    getCountryDatas();
    configuration
      .getAPI({
        url: "common/list-order-no",
        params: { collectionName: "languages", lang_code: "EN" },
      })
      .then((data) => {
        if (data.status === 200) {
          let orderNoArr = [];
          _.each(data.payload, (singleRec) => {
            orderNoArr.push({
              title: singleRec.title,
              value: singleRec.order_no,
              id: singleRec.order_no,
            });
          });
          const orderNoObj = {
            id: 1,
            title: "Order No",
            name: "order_no",
            type: "Dropdown",
            options: orderNoArr,
          };
          setFieldArr((prevFields) => [...prevFields, orderNoObj]);
        }
      })
      .catch((error) => {
        return toast.error(error.message);
      });
  }, []);

  function getCountryDatas() {
    configuration
      .getAPI({ url: "country/list", params: {} })
      .then((data) => {
        if (data.status === 200) {
          let countryOptions = [];
          if (data.payload.length > 0) {
            countryOptions = data.payload.map((element) => ({
              title: element.name,
              value: element.country_id,
              id: element.country_id,
            }));
          }

          setCountryOpt(countryOptions);
          console.log("countryOptions");
          console.log(countryOptions);

          // Update the specific field in fieldArr
          setFieldArr((prevFields) =>
            prevFields.map((field) =>
              field.name === "country_id"
                ? { ...field, options: countryOptions }
                : field
            )
          );
        }
      })
      .catch((error) => {
        return toast.error(error.message);
      });
  }

  const handleSubmit = () => {
    if (handleValidation()) {
      setIsLoader(true);
      const formData = new FormData();
      formData.append("icon", icon);
      formData.append("fields", JSON.stringify({ ...fields, lang_code: "EN" }));
      configuration
        .postFormDataAPI({ url: "language/create", params: formData })
        .then((data) => {
          setIsLoader(false);
          if (data.status === 200) {
            history.push("/language");
            toast.success("Record added successfully");
          } else if (data.error) {
            return toast.error(data.error.message);
          } else {
            return toast.error("Something went wrong");
          }
        })
        .catch((error) => {
          setIsLoader(false);
          return toast.error(error.message);
        });
    }
  };

  function handleChange(field, e) {
    if (field === "icon") {
      setIcon(e.target.files[0]);
      setFields({ ...fields, [field]: URL.createObjectURL(e.target.files[0]) });
    } else {
      setFields({ ...fields, [field]: e.target.value });
    }
  }

  function cancleImage(field, e) {
    setIcon(null);
    setFields({ ...fields, [field]: "" });
  }

  return (
    <>
      {isLoader ? <Loader /> : ""}
      <Breadcrumb module={labels.addLanguage} />
      <AddEditSection
        title="Add Language"
        path="/language"
        fields={fieldArr}
        fieldError={errors}
        fieldValue={fields}
        handleChange={handleChange}
        cancleImage={cancleImage}
        handleSubmit={handleSubmit}
      />
    </>
  );
}

export default Add;
